<div class=" page page-album">
	<p style="margin-top: 100px;">Welcome to page {{album}}</p>
	<app-browse [page]="'album'" [param]="album"></app-browse>
</div>